import React from 'react';
import { formatLongDate, hasTheme } from '../data/events';
import { downloadIcs, googleCalendarUrl } from '../lib/calendar';
import styles from './EventDetail.module.css';

/**
 * Event detail body shared by the home-strip modal and the Revive Nights
 * page modal. Confirmed, non-sabbath events get functional actions:
 * download .ics, open in Google Calendar, get directions.
 */
export default function EventDetail({ event }) {
  const isSabbath = event.isSabbath;
  const hasActions = !event.tbd && !isSabbath;

  return (
    <div className={styles.detail}>
      <span className={styles.eyebrow}>
        {isSabbath ? 'A month of rest' : 'Revive Night'}
      </span>
      <h3 className={styles.title}>
        {isSabbath ? event.edition : `Revive Night: ${event.edition}`}
      </h3>

      <dl className={styles.list}>
        {!isSabbath && hasTheme(event) && (
          <div className={styles.row}>
            <dt>Theme</dt>
            <dd>{event.theme}</dd>
          </div>
        )}
        {event.verseRef && event.verseText && (
          <div className={styles.row}>
            <dt>{event.verseRef}</dt>
            <dd className={styles.verse}>
              <em>“{event.verseText}”</em>
            </dd>
          </div>
        )}
        <div className={styles.row}>
          <dt>Date</dt>
          <dd>
            {event.tbd ? (
              <span className={styles.mute}>To be announced</span>
            ) : (
              formatLongDate(event.date)
            )}
          </dd>
        </div>
        <div className={styles.row}>
          <dt>Time</dt>
          <dd>{event.timeLabel}</dd>
        </div>
        <div className={styles.row}>
          <dt>Location</dt>
          <dd>
            {event.locationUrl ? (
              <a
                className={styles.link}
                href={event.locationUrl}
                target="_blank"
                rel="noreferrer"
              >
                {event.locationName} <span aria-hidden="true">↗</span>
              </a>
            ) : (
              <span className={styles.mute}>{event.locationName}</span>
            )}
          </dd>
        </div>
      </dl>

      {hasActions && (
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.actionBtn}
            onClick={() => downloadIcs(event)}
          >
            Add to calendar <span aria-hidden="true">⤓</span>
          </button>
          <a
            className={styles.actionBtn}
            href={googleCalendarUrl(event)}
            target="_blank"
            rel="noreferrer"
          >
            Google Calendar <span aria-hidden="true">↗</span>
          </a>
          {event.locationUrl && (
            <a
              className={styles.actionBtn}
              href={event.locationUrl}
              target="_blank"
              rel="noreferrer"
            >
              Directions <span aria-hidden="true">↗</span>
            </a>
          )}
        </div>
      )}
    </div>
  );
}
